"use client";

import { Label } from "@/components/ui/label";
import { TagInput } from "emblor";
import { useId, useState } from "react";

export default function TagInputs({ tags, setTags, label = 'فیلد برچسب', placeholder = 'برچسب وارد کن' }: any) {
  const formattedTags = tags.map((tag: any, index: any) => ({ id: index, text: tag }));
  const id = useId();
  const [activeTagIndex, setActiveTagIndex] = useState<number | null>(null);

  return (
    <div className="*:not-first:mt-2">
      <Label htmlFor={id}>{label}</Label>
      <TagInput
        id={id}
        tags={formattedTags}
        setTags={setTags}
        placeholder={placeholder}
        styleClasses={{
          inlineTagsContainer: "border-input rounded-md bg-[#0A0512]/50 border-[1px] border-[#7c44ff3f] shadow-sm backdrop-blur-lg shadow-xs transition-[color,box-shadow] focus-within:border-ring outline-none focus-within:ring-offset-background transition-all duration-500 focus-within:ring-ring/50 p-1 gap-1",
          input: "w-full min-w-[80px] shadow-none px-2 h-7",
          tag: {
            body: "h-7 relative bg-[#1A1525] border border-input hover:bg-[#1A1525] rounded-md font-medium text-xs ps-7 pe-2 pt-[2.4px]",
            closeButton: "absolute right-0 -inset-y-px -end-px p-0 rounded-e-md flex size-7 transition-[color,box-shadow] outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] text-muted-foreground/80 hover:text-foreground",
          },
        }}
        activeTagIndex={activeTagIndex}
        setActiveTagIndex={setActiveTagIndex}
      />
    </div>
  );
}
